var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d0fbdd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.29L4.02 14.5C4.28 11.42 6.86 9 10 9h28c3.14 0 5.72 2.42 5.98 5.5L24 25.29zM23.76 28.48C22.64 30.4 22 32.62 22 35c0 2.16.53 4.2 1.47 6H10c-3.31 0-6-2.69-6-6V17.89l19.29 10.43C23.44 28.4 23.6 28.46 23.76 28.48zM44 17.89v7.74c-2.04-1.97-4.73-3.28-7.72-3.56L44 17.89zM46 35c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11S46 28.925 46 35zM34.707 31.293l-2-2c-.391-.391-1.023-.391-1.414 0l-2 2c-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0L31 32.414V40c0 .553.447 1 1 1s1-.447 1-1v-7.586l.293.293C33.488 32.902 33.744 33 34 33s.512-.098.707-.293C35.098 32.316 35.098 31.684 34.707 31.293zM40.707 37.293c-.391-.391-1.023-.391-1.414 0L39 37.586V30c0-.553-.447-1-1-1s-1 .447-1 1v7.586l-.293-.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2 2C37.488 40.902 37.744 41 38 41s.512-.098.707-.293l2-2C41.098 38.316 41.098 37.684 40.707 37.293z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.45217130974982706798ca4bcf1a8a72.svg";
export { ForwardRef as ReactComponent };